<template lang="pug">
    .hzDialogCover(ref="dialogContainer", v-show="isShow")
        .hzDialog(:class="type")
            .dialogHd(v-if="title") {{title}}
                .dialogClose(@click="removeHanlder") ×
            .dialogBd
                slot
            .dialogFt(v-if="foot")
                button(ref="btnConfirm", class="primary mr10" type="button", @click="confirmHanlder") 确定
                button(ref="btnCancel", type="button", @click="removeHanlder") 取消
</template>

<script>
    export default {
        name: 'hz-dialog',
        props: {
            title: String,
            foot: { type: Boolean, default: true },
            value: { type: Boolean, default: false },
            isDeleteDom: { type: Boolean, default: false },
            isAutoClose: { type: Boolean, default: true },
            type: String
        },

        data() {
            return {
                isShow: false
            }
        },

        watch: {
            value: {
                handler: function(val) {
                    this.isShow = val;
                },
                immediate: true
            }
        },

        mounted() {
            $(this.$refs.dialogContainer).appendTo(document.body);
        },
        beforeDestroy() {
            this.$refs.dialogContainer && $(this.$refs.dialogContainer).remove();
        },

        methods: {
            confirmHanlder() {
                this.$emit('confirm', this.$el);
                if(this.isAutoClose) {
                    //confirm 自己关闭---
                    this.$emit('input', false);
                    if(this.isDeleteDom){ 
                        $(this.$el).remove();
                    }
                    else {
                        this.isShow = false;
                    }
                }
            },

            hide() {
                this.removeHanlder();
            },

            removeHanlder() {
                this.$emit('input', false);
                this.$emit('cancel');
                if(this.isDeleteDom){
                    $(this.$el).remove();
                }
                else{
                    this.isShow = false;
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/dialog.vue